import Dropdown from "./dropdown";
import TopicBox from "./topic-box";
export interface SearchBoxFilterProps {
  title: string;
  icon: string;
  onChange: (value: string) => void;
  options: { [id: string]: string };
  selectedValues: null | string[];
}
function DropdownFilter({
  title,
  selectedValues,
  onChange,
  icon,
  options,
}: SearchBoxFilterProps) {
  return (
    <TopicBox title={title} icon={icon}>
      <Dropdown options={options} selectedValues={selectedValues} onChange={onChange} />
    </TopicBox>
  );
}

export default DropdownFilter;
